<template>
    <div class="purchase-order-list">
        <div class="flex flex-wrap items-center justify-between mb-4">
            <div class="flex items-center">
                 <!-- Search removed as per request -->
            </div>
            <div>
                <vs-button icon="icon-plus" icon-pack="feather" @click="$emit('create')">Create New PO</vs-button>
            </div>
        </div>

        <!-- Search and Filter Row -->
        <vs-row class="mb-3">
            <vs-col vs-xs="12" vs-sm="5" vs-lg="5" class="px-0 pr-2 mb-2">
                <vs-input
                    class="w-full"
                    placeholder="Search by PO number, remarks..."
                    v-model="filters.search"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0 pr-2 mb-2">
                <SelectForeign
                    :model.sync="filters.filter_vendor"
                    label=""
                    placeholder="Filter by Vendor"
                    :multiple="false"
                    :load_initial="true"
                    :label_keys="['code']"
                    :show_id_in_label="false"
                    :endpoint="vendorEndpoint"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="true"
                    :result_filter="item => item.is_active"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="px-0 mb-2">
                <InputSelect
                    :model.sync="filters.filter_status"
                    label=""
                    placeholder="Filter by Status"
                    container_class="w-full"
                    :options="status_options"
                />
            </vs-col>
        </vs-row>

        <vx-card>
            <vs-table :data="items" stripe hoverFlat noDataText="">
                <template slot="thead">
                    <vs-th>Vendor Code / Name</vs-th>
                    <vs-th>FY</vs-th>
                    <vs-th>PO Order Number</vs-th>
                    <vs-th>PO Date</vs-th>
                    <vs-th>PO Status</vs-th>
                    <vs-th>Total Amount</vs-th>
                    <vs-th>Remarks</vs-th>
                    <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="ind" v-for="(tr, ind) in data">
                        <vs-td :data="tr.vendor_detail">
                            <span v-if="tr.vendor_detail">
                                {{ tr.vendor_detail.code || '' }}<span v-if="tr.vendor_detail.name"> / {{ tr.vendor_detail.name }}</span>
                            </span>
                            <span v-else>-</span>
                        </vs-td>

                        <vs-td :data="tr.fy_detail">
                            {{ (tr.fy_detail && tr.fy_detail.fy_year) ? tr.fy_detail.fy_year : '-' }}
                        </vs-td>

                        <vs-td :data="tr.po_number">
                            {{ tr.po_number || '-' }}
                        </vs-td>

                        <vs-td :data="tr.po_date">
                            {{ tr.po_date }}
                        </vs-td>

                        <vs-td :data="tr.status">
                            <vs-chip :color="getStatusColor(tr.status)">
                                {{ tr.status ? tr.status.toUpperCase() : 'PENDING' }}
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="tr.total_value">
                            {{ tr.total_value || tr.total_amount || 0 }}
                        </vs-td>

                         <vs-td :data="tr.remark">
                            {{ tr.remark || '-' }}
                        </vs-td>

                        <vs-td>
                            <div class="flex items-center">
                                <div class="flex items-center" v-if="canApprovePO">
                                    <vx-tooltip text="Approved" v-if="tr.status && tr.status.toLowerCase() === 'approved'">
                                        <vs-button 
                                            radius 
                                            color="success" 
                                            type="filled" 
                                            icon-pack="feather" 
                                            icon="icon-check" 
                                            class="mr-2"
                                            size="small"
                                            disabled
                                        ></vs-button>
                                    </vx-tooltip>

                                    <vx-tooltip text="Approve" v-else>
                                        <vs-button 
                                            radius 
                                            color="success" 
                                            type="filled" 
                                            icon-pack="feather" 
                                            icon="icon-check" 
                                            class="mr-2"
                                            size="small"
                                            @click="confirmApprove(tr)"
                                        ></vs-button>
                                    </vx-tooltip>
                                </div>

                                <vx-tooltip :text="tr.status && tr.status.toLowerCase() === 'approved' ? 'View' : 'View/Edit'">
                                    <vs-button 
                                        radius 
                                        color="warning" 
                                        type="filled" 
                                        icon-pack="feather" 
                                        :icon="tr.status && tr.status.toLowerCase() === 'approved' ? 'icon-eye' : 'icon-edit'" 
                                        size="small"
                                        @click="$emit('edit', tr)"
                                    ></vs-button>
                                </vx-tooltip>

                                 <vx-tooltip text="Delete" v-if="isActuallyAdmin">
                                    <vs-button 
                                        radius 
                                        color="danger" 
                                        type="filled" 
                                        icon-pack="feather" 
                                        icon="icon-trash" 
                                        size="small"
                                        class="ml-2"
                                        @click="confirmDelete(tr)"
                                    ></vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
             <template v-if="!loading && items.length === 0">
                <div class="text-center p-4">
                    <p class="text-muted mb-0" v-if="has_active_filters">No results found for the current search/filter criteria.</p>
                    <p class="text-muted mb-0" v-else>No data available</p>
                </div>
            </template>
             <template v-if="total_results">
                <vs-row class="mt-3 text-center">
                    <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
                </vs-row>
            </template>
        </vx-card>
    </div>
</template>

<script>
import { Request } from '../../utils/requests';

export default {
    data() {
        let offset = parseInt(this.$route.query.offset || 0);
        let limit = parseInt(this.$route.query.limit || 10);
        let current_page = offset == 0 ? 1 : Math.ceil(offset / limit) + 1;

        return {
            items: [],
            loading: false,
            total_results: null,
            current_page: current_page,
            filters: {
                search: this.$route.query.search || null,
                filter_vendor: this.$route.query.filter_vendor ? parseInt(this.$route.query.filter_vendor) : null,
                filter_status: this.$route.query.filter_status || null,
                offset: offset,
                limit: limit
            },
            status_options: [
                { value: null, label: 'All Status' },
                { value: 'pending', label: 'Pending' },
                { value: 'approved', label: 'Approved' },
                { value: 'rejected', label: 'Rejected' },
            ]
        }
    },
    computed: {
canApprovePO() {
            let role = 'Super Admin'; // Default fallback matching navbar logic
            
            if (this.$store.state.organisation.organisation_user && 
                this.$store.state.organisation.organisation_user.role && 
                this.$store.state.organisation.organisation_user.role.role) {
                role = this.$store.state.organisation.organisation_user.role.role;
            }
            
            // Normalize: 'Maintenance Manager' -> 'maintenance_manager'
            const standardizedRole = role.toLowerCase().replace(/ /g, '_');
            
            return ['maintenance_manager', 'admin', 'super_admin'].includes(standardizedRole);
        },
        total_pages() {
            if(this.total_results == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_results/this.filters.limit)
        },
        has_active_filters() {
            return !!(this.filters.search || this.filters.filter_vendor || this.filters.filter_status)
        },
        vendorEndpoint() {
            let orgId = this.$store.state.organisation.organisation && this.$store.state.organisation.organisation.id;
            return orgId ? `${this.$store.state.apiendpoints.master_vendor}?organisation=${orgId}&is_active=true` : `${this.$store.state.apiendpoints.master_vendor}?is_active=true`;
        },
        isActuallyAdmin() {
            if (this.$store.state.organisation.organisation_user && this.$store.state.organisation.organisation_user.role) {
                let role = this.$store.state.organisation.organisation_user.role.role.toLowerCase();
                return role == 'admin' || role == 'super admin';
            }
            return this.$store.state.auth.userRole == 'admin';
        }
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                if (this.current_page == null) return;
                // Only update offset and limit in query params
                this.$router.push({ 
                    name: this.$route.name, 
                    query: {
                        offset: newV.offset,
                        limit: newV.limit,
                        search: newV.search || undefined,
                        filter_vendor: newV.filter_vendor || undefined,
                        filter_status: newV.filter_status || undefined
                    } 
                }).catch(() => {});
            }
        },
        "$route.query"(newV) {
            this.fetchItems();
        },
        current_page(newV, oldV) {
            if (newV == oldV) return;
            this.filters.offset = (newV - 1) * this.filters.limit;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let offset = parseInt(this.$route.query.offset || 0);
            let limit = parseInt(this.$route.query.limit || 10);
            this.filters.offset = offset;
            this.filters.limit = limit;
            this.filters.search = this.$route.query.search || null;
            this.filters.filter_vendor = this.$route.query.filter_vendor ? parseInt(this.$route.query.filter_vendor) : null;
            this.filters.filter_status = this.$route.query.filter_status || null;
            this.calculate_page();
            
            // Set query params in URL if they don't exist
            if (!this.$route.query.offset || !this.$route.query.limit) {
                this.$router.replace({ 
                    name: this.$route.name, 
                    query: { 
                        ...this.$route.query,
                        offset: this.filters.offset, 
                        limit: this.filters.limit 
                    } 
                }).catch(() => {});
            }
            
            this.fetchItems();
        },
        calculate_page() {
            if (this.filters.offset == 0) {
                this.current_page = 1;
            } else {
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit) + 1;
            }
        },
        fetchItems() {
            this.loading = true;
            this.$vs.loading();
            let orgId = this.$store.state.organisation.organisation && this.$store.state.organisation.organisation.id;
            let url = this.$store.state.apiendpoints.purchase_order;
            
            let payload = {
                offset: this.filters.offset,
                limit: this.filters.limit
            }

            if (orgId) {
                payload.organisation = orgId;
            }

            Request(this, 'GET', url, payload).then(res => {
                this.loading = false;
                this.$vs.loading.close();
                if (res && res.data && Array.isArray(res.data)) {
                    this.items = res.data;
                    this.total_results = res.count !== undefined ? res.count : res.data.length;
                } else if (res && res.results) {
                    this.items = res.results;
                    this.total_results = res.count || res.results.length;
                } else if (Array.isArray(res)) {
                    this.items = res;
                    this.total_results = res.length;
                } else {
                    this.items = [];
                    this.total_results = 0;
                }
                if (this.filters.search) {
                    const q = this.filters.search.toLowerCase()
                    this.items = this.items.filter(item =>
                        (item.po_number && item.po_number.toLowerCase().includes(q)) ||
                        (item.remark && item.remark.toLowerCase().includes(q)) ||
                        (item.vendor_detail && item.vendor_detail.code && item.vendor_detail.code.toLowerCase().includes(q))
                    )
                    this.total_results = this.items.length
                }
                if (this.filters.filter_vendor) {
                    this.items = this.items.filter(item => item.vendor === this.filters.filter_vendor || (item.vendor_detail && item.vendor_detail.id === this.filters.filter_vendor))
                    this.total_results = this.items.length
                }
                if (this.filters.filter_status) {
                    this.items = this.items.filter(item => (item.status || 'pending').toLowerCase() === this.filters.filter_status.toLowerCase())
                    this.total_results = this.items.length
                }
                this.calculate_page();
            }).catch(() => {
                this.loading = false;
                this.$vs.loading.close();
            });
        },
        getStatusColor(status) {
            if (!status) return 'warning';
            status = status.toLowerCase();
            if (status === 'approved') return 'success';
            if (status === 'rejected') return 'danger';
            return 'primary';
        },
        confirmApprove(po) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger', 
                title: 'Are you sure?',
                text: `Are you sure you want to approve PO Number: ${po.po_number}?`,
                acceptText: 'Yes, Approve',
                cancelText: 'Cancel',
                accept: () => this.approvePo(po)
            });
        },
        approvePo(po) {
            let url = `${this.$store.state.apiendpoints.purchase_order}${po.id}/`;
            // Assuming standard patch for status update
            Request(this, 'PATCH', url, null, { status: 'approved' }).then(res => {
                this.$vs.notify({ title: 'Success', text: 'PO Approved', color: 'success' });
                this.fetchItems();
            }).catch(err => {
                this.$vs.notify({ title: 'Error', text: 'Failed to approve PO', color: 'danger' });
                console.error(err);
            });
        },
        confirmDelete(po) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirm Delete',
                text: `Are you sure you want to delete PO Number: ${po.po_number}? This action cannot be undone.`,
                acceptText: 'Delete',
                cancelText: 'Cancel',
                accept: () => this.deletePo(po)
            });
        },
        deletePo(po) {
            this.$vs.loading();
            let url = `${this.$store.state.apiendpoints.purchase_order}${po.id}/`;
            Request(this, 'DELETE', url).then(res => {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: 'Success',
                    text: 'Purchase Order deleted successfully',
                    color: 'success'
                });
                this.fetchItems();
            }).catch(err => {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: 'Error',
                    text: 'Failed to delete Purchase Order',
                    color: 'danger'
                });
                console.error(err);
            });
        }
    }
}
</script>
